import { createSelector } from '@reduxjs/toolkit';

// Memoized empty objects to avoid creating new references for the selectors
const emptyObject = {};
const emptyArray = [];
const defaultPinnedColumns = {
    left: emptyArray,
    right: emptyArray,
};

export const selectGridState = createSelector(
    (state, gridName) => state.dataGridState[gridName] || emptyObject,
    gridState => gridState
);

export const selectActiveFilters = createSelector(
    selectGridState,
    gridState => gridState.activeFilters || emptyArray
);

export const selectSearchFilters = createSelector(
    selectGridState,
    gridState => gridState.searchFilters || emptyArray
);

export const selectAdvancedFilters = createSelector(
    selectGridState,
    gridState => gridState.advancedFilters || emptyArray
);

export const selectClearAllAdvancedFilterId = createSelector(
    selectGridState,
    gridState => gridState.clearAllAdvancedFilterId
);

export const selectColumnVisibility = createSelector(
    selectGridState,
    gridState => gridState.columnVisibility || emptyObject
);

export const selectColumnDimensions = createSelector(
    selectGridState,
    gridState => gridState.columnDimensions || emptyArray
);

export const selectPinnedColumns = createSelector(
    selectGridState,
    gridState => gridState.pinnedColumns || defaultPinnedColumns
);

export const selectColumnOrdering = createSelector(
    selectGridState,
    gridState => gridState.columnOrdering || emptyArray
);

export const selectDensity = createSelector(
    selectGridState,
    gridState => gridState.density || 'compact'
);

export const selectSortModel = createSelector(
    selectGridState,
    gridState => gridState.sortModel || emptyArray
);

export const selectRowGroupingModel = createSelector(
    selectGridState,
    gridState => gridState.rowGroupingModel || emptyArray
);

export const selectGridViewActiveId = createSelector(
    selectGridState,
    gridState => gridState.activeId
);

export const selectDataLoading = createSelector(
    selectGridState,
    gridState => gridState.dataLoading
);

export const selectActiveQuery = createSelector(
    selectGridState,
    gridState => gridState.activeQuery
);

export const selectActivePaginationPage = createSelector(
    selectGridState,
    gridState => gridState.activePaginationPage
);

export const selectData = createSelector(
    selectGridState,
    gridState => gridState.data
);

export const selectTotalCount = createSelector(
    selectGridState,
    gridState => gridState.totalCount
);

export const selectInitialized = createSelector(
    selectGridState,
    gridState => gridState.initialized
);

export const selectAdvancedFilterCount = createSelector(
    selectGridState,
    gridState => gridState.advancedFilterCount
);

export const selectDisableQueryRules = createSelector(
    selectGridState,
    gridState => gridState.disableQueryRules
);
